import React, { useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Box, LinearProgress, Typography } from "@mui/material";
import {
  useKivunovaTranslation,
  localizedPath
} from "@kivunova/kivufrontendcommon";
import { useIremboSubscriptionPaymentFlow } from "../../hooks/useIremboSubscriptionPaymentFlow";
import { ROUTE_SUBSCRIPTIONS } from "../../constants/routes";

/**
 * Legacy checkout URL: runs create payment → Irembo invoice → widget, then navigates to subscriptions.
 * Prefer invoking {@link useIremboSubscriptionPaymentFlow} from Activate / Order summary instead.
 */
const CheckoutOrchestrator: React.FC = () => {
  const { subscriptionId } = useParams<{ subscriptionId: string }>();
  const { t } = useKivunovaTranslation();
  const navigate = useNavigate();
  const { startCheckout, isRunning } = useIremboSubscriptionPaymentFlow();
  const startedRef = useRef(false);

  useEffect(() => {
    if (!subscriptionId?.trim()) {
      navigate(localizedPath(ROUTE_SUBSCRIPTIONS), { replace: true });
      return;
    }
    if (startedRef.current) return;
    startedRef.current = true;
    void startCheckout(subscriptionId, {
      successDestination: "success",
      redirectOnIncomplete: true
    });
  }, [navigate, startCheckout, subscriptionId]);

  return (
    <Box sx={{ p: 4, maxWidth: 480, mx: "auto" }}>
      <Typography variant="h6" gutterBottom>
        {t("membership.checkout.openingPayment", "Opening payment…")}
      </Typography>
      {isRunning && <LinearProgress sx={{ mt: 2 }} />}
    </Box>
  );
};

export default CheckoutOrchestrator;
